import { Component, OnInit } from '@angular/core';
import { OrderService } from '../services/order.service';
import { environment } from '../../../../environments/environment';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { UserAuthService } from '../../../services/user/user-auth.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginDialogComponent } from '../../account/login-dialog/login-dialog.component';
import { AlertService } from '../../../services/alert/alert.service';
import {
    CartFace,
    CartInfos,
    CartScreenPark,
    CompatibleTypeEnum,
} from '../model/store.model';
import { DateTime } from 'luxon';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PlayerComponent } from '../../spots/player/player.component';
import { Crisp } from 'crisp-sdk-web';
import { TitleService } from '../../../services/title/title.service';
import { ScreenService } from '../services/screen.service';
declare const fbq: any;

@Component({
    selector: 'app-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements OnInit {
    //#region Variables
    public window = <Window>window;

    /**
     * Url de base de l'API a appeler
     */
    public baseUrl: string;
    /**
     * Nom de la campagne choisie par le client
     */
    public campaignName: string;
    /**
     * Date de début de la campagne
     */
    public campaignStartDate: string | number | Date;
    /**
     * Date de fin de la campagne
     */
    public campaignEndDate: string | number | Date;
    /**
     * Faces sélectionnées `number` ou `string` si vient du localStorage
     */
    public selectedFaceId: number[] | string[];
    /**
     * Infos du panier
     */
    public cartItem: CartInfos;
    /**
     * `true`si le panier est chargé
     */
    public isCartLoaded: boolean = false;
    /**
     * `true` si le panier ne lève pas de warning
     */
    public isCartCompatible: boolean = true;
    /**
     * `true` au clic sur 'Aller au paiement' => chargement
     */
    public isGoingToPay: boolean = false;
    /**
     * Affichage du paiement (entrer les infos de CB,...)
     */
    public enableCheckout: boolean = false;
    /**
     * Numéro de devis pour le paiement
     */
    public orderId: number;
    /**
     * Validateur des CGV
     */
    public isCGVok: boolean = false;
    public spotOrdered: number = null;
    public templateOrdered: number = null;
    public isDeviceIsDesktop: boolean = false;
    //#endregion Variables

    // MARK: CONSTRUCTOR
    constructor(
        public order$: OrderService,
        public datePipe: DatePipe,
        private readonly router: Router,
        private readonly userAuth$: UserAuthService,
        private readonly dialog: MatDialog,
        private readonly alert$: AlertService,
        public title$: TitleService,
        private readonly waiting$: WaitingService,
        public screen$: ScreenService
    ) {
        this.baseUrl = environment.apiBaseStore;
        setTimeout(() => {
            this.title$.next('Panier');
        }, 0);
    }

    ngOnInit(): void {
        if (window.innerWidth <= 900) {
            this.isDeviceIsDesktop = false;
        } else {
            this.isDeviceIsDesktop = true;
        }
        if (!Crisp.isCrispInjected()) {
            Crisp.configure('7d4a0471-984f-4f44-a5cd-e0ef1ef779b4');
            if(!this.isDeviceIsDesktop){
                Crisp.chat.hide();
            }
        } else {
            Crisp.chat.show();
            if(!this.isDeviceIsDesktop){
                Crisp.chat.hide();
            }
        }
        this.campaignName = localStorage.getItem('campaignName');
        this.selectedFaceId = localStorage.getItem('selectedFace')?.split(',');
        this.campaignStartDate = localStorage.getItem('campaignStartDate');
        this.campaignEndDate = localStorage.getItem('campaignEndDate');
        this.spotOrdered = Number(localStorage.getItem('spotOrdered'));
        this.templateOrdered = Number(localStorage.getItem('templateOrdered'));
        if (
            this.campaignName == null ||
            this.selectedFaceId == null ||
            this.campaignStartDate == null ||
            this.campaignEndDate == null
        ) {
            this.alert$.show({
                message: 'Informations du panier manquantes',
                duration: 700,
            });
            this.goBack();
        }

        //Get startDate
        this.campaignStartDate = DateTime.fromJSDate(
            new Date(this.campaignStartDate)
        ).toISODate();

        //Get EndDate
        this.campaignEndDate = DateTime.fromJSDate(
            new Date(this.campaignEndDate)
        ).toISODate();

        this.loadCart();
    }

    /**
     * Charge le panier
     */
    private loadCart() {
        this.isCartLoaded = false;
        const waitingId: string = this.waiting$.start();
        this.order$
            .getCart(
                this.selectedFaceId as number[],
                this.campaignStartDate,
                this.campaignEndDate,
                this.campaignName,
                10,
                this.spotOrdered,
                this.templateOrdered,
            )
            .subscribe({
                next: (cartResult: CartInfos) => {
                    this.waiting$.end(waitingId);
                    if (cartResult != null) {
                        this.cartItem = cartResult;
                        this.cartItem.vat = this.cartItem.tt - this.cartItem.ht;
                        this.cartItem.sp.forEach(
                            (screenPark: CartScreenPark) => {
                                screenPark.expend = false;
                                let i: number = 0;
                                screenPark.fAs.forEach((face: CartFace) => {
                                    if (i > 4) {
                                        face.hide = true;
                                    }

                                    if (!face.ic || face?.nf?.length > 0) {
                                        this.isCartCompatible = false;
                                        this.alert$.show({
                                            message:
                                                'Des articles de votre panier ne sont malheuresement pas disponibles',
                                            duration: 1700,
                                        });
                                    }
                                    i++;
                                });
                            }
                        );
                    }
                    this.isCartLoaded = true;
                },
                error: (err) => {
                    this.waiting$.end(waitingId);
                    console.error(err);

                    this.alert$.show({
                        message:
                            'Erreur lors de la récupération de votre panier, veuillez réessayer plus tard',
                        duration: 1700,
                    });

                    this.isCartLoaded = true;
                },
            });
    }

    /**
     * Annule le paiement ou retourne sur la map du store
     */
    public goBack() {
        if (this.enableCheckout) {
            this.enableCheckout = false;
        } else {
            this.goToMap();
            // this.goToSpot();
        }
    }
    /**
    * Retourne sur la map du store
    */
    public goToSpot(paramToEdit?: CartEditParam) {
        let redirectUrl: string = '/store/spot';

        if (redirectUrl != null) {
            redirectUrl += '?e=' + paramToEdit;
        }
        this.router.navigateByUrl(redirectUrl);
    }

    /**
     * Retourne sur la map du store
     */
    public goToMap(paramToEdit?: CartEditParam) {
        this.trackGoToMap();
        let redirectUrl: string = '/store';

        if (redirectUrl != null) {
            redirectUrl += '?e=' + paramToEdit;
        }
        this.router.navigateByUrl(redirectUrl);
    }

    /**
     * Active les trackers d'analytics lors du retour vers la carte
     */
    private trackGoToMap() {
        if (this.window && this.window.dataLayer != null) {
            this.window.dataLayer = window.dataLayer || [];
            this.window.dataLayer.push({
                event: 'retour_carte',
            });
            fbq('track', 'retour_carte', {});

        }
        else {
            this.window.dataLayer = window.dataLayer || [];
            this.window.dataLayer.push({
                event: 'retour_carte',
            });
            fbq('track', 'retour_carte', {});

        }
    }

    /**
     * Retourne sur la page de spots
    */


    expendSP(sp: any) {
        sp.expend = true;
        sp.fAs.forEach((face) => {
            face.hide = false;
        });
    }

    minusSP(sp: any) {
        sp.expend = false;
        let i = 0;
        sp.fAs.forEach((face) => {
            if (i > 4) {
                face.hide = true;
            }
            i++;
        });
    }

    /**
     * Appelé au click sur 'Aller au paiement'
     * Vérifie si l'utilisateur est connecté et le redirige vers le paiment si c'est ok
     */
    goToPay() {
        if (this.window && this.window.dataLayer != null) {
            this.window.dataLayer = window.dataLayer || [];
            this.window.dataLayer.push({
                event: 'passage_paiement',
            });
            fbq('track', 'passage_paiement', {});

        }
        else {
            this.window.dataLayer = window.dataLayer || [];
            this.window.dataLayer.push({
                event: 'passage_paiement',
            });
            fbq('track', 'passage_paiement', {});

        }
        this.isGoingToPay = true;
        //Check connection
        if (this.userAuth$.isLogged()) {
            //Continue to stripe
            this.goToCheckout();
        } else {
            this.alert$.show({
                message: "Veuillez d'abord vous authentifier",
                duration: 1000,
            });

            const dialogOpts = window.innerWidth < 900 ?
                {
                    maxWidth: '100vw',
                    maxHeight: '100vh',
                    height: '100%',
                    width: '100%',
                    closeOnNavigation: true,
                    panelClass: 'loginDiag',
                    disableClose: true,
                } :
                {
                    closeOnNavigation: true,
                    panelClass: 'loginDiag',
                    disableClose: true,
                };

            const loginDialogRef = this.dialog.open(LoginDialogComponent, dialogOpts);

            loginDialogRef.afterClosed().subscribe(() => {
                if (this.userAuth$.isLogged()) {
                    this.loadCart();
                    if (this.isCartCompatible) {
                        this.goToCheckout();
                    }
                } else {
                    this.loadCart();
                    this.isGoingToPay = false;
                }
            });
        }
    }

    /**
     * Créé le panier en base et redirige vers le paiement
     */
    private goToCheckout() {
        this.order$
            .createCart(
                this.selectedFaceId as number[],
                this.campaignStartDate,
                this.campaignEndDate,
                this.campaignName, null,
                this.spotOrdered,
                this.templateOrdered
            )
            .subscribe({
                next: (createdOrderId: number) => {
                    this.orderId = createdOrderId;
                    this.enableCheckout = true;
                    this.isGoingToPay = false;
                    if (this.window && this.window.dataLayer != null) {
                        this.window.dataLayer = window.dataLayer || [];
                        this.window.dataLayer.push({
                            event: 'panier_creer',
                        });
                        fbq('track', 'panier_creer', {});

                    }
                    else {
                        this.window.dataLayer = window.dataLayer || [];
                        this.window.dataLayer.push({
                            event: 'panier_creer',
                        });
                        fbq('track', 'panier_creer', {});

                    }

                    window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: 'smooth'
                    })
                },
                error: (err: HttpErrorResponse) => {
                    console.error(err);

                    this.alert$.show({
                        message:
                            'Erreur lors de du passage au paiement, veuillez réessayer plus tard',
                        duration: 1700,
                    });
                    this.isGoingToPay = false;
                },
            });
    }

    /**
     *
     * @param ic IsCompatible Type
     * @returns Le texte correspondant pour l'afficher dans le paniers
     */
    getOccupedType(ic: CompatibleTypeEnum) {
        switch (ic) {
            case CompatibleTypeEnum.NotInstall:
                return 'Ecran pas encore installé';
            case CompatibleTypeEnum.UnInstall:
                return 'Ecran désinstallé';

            case CompatibleTypeEnum.Full:
            default:
                return 'Ecran plein';
        }
    }

    /**
     * Ouvre en grand l'image
     */
    openImgDetail(fileStorageId: string) {
        const detailImgDialogRef = this.dialog.open(PlayerComponent);

        detailImgDialogRef.componentInstance.fileStorageId = fileStorageId;
        detailImgDialogRef.componentInstance.loadVideo();
    }
}

//#region Enums

export enum CartEditParam {
    Name = 0,
    Dates = 1,
    Screens = 2,
}

//#endregion Enums
